import { useContext, useMemo } from "react";

import { DataContext } from "contexts/Data";
import useVariant from "./useVariant";

/**
 * Only use this hook under DataContext
 * @returns {boolean} - return `true` only if the config & variant both has loaded
 */
export default function useConfigurationLoading(): { loaded: boolean; loadError: boolean } {
  const { loaded, loadError } = useContext(DataContext);
  const variant = useVariant();

  const variantLoaded = useMemo(() => {
    if (!variant) return false;
    return true;
  }, [variant]);

  return useMemo(() => {
    return { loaded: loaded && variantLoaded, loadError };
  }, [loaded, loadError, variantLoaded]);
}
